import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../assets/img/lodgix-icon-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-67e85cdf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_LoginPage = _resolveComponent("LoginPage")!
  const _component_HousekeeperComponent = _resolveComponent("HousekeeperComponent")!
  const _component_MainMenu = _resolveComponent("MainMenu")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { mode: "ios" }, {
    default: _withCtx(() => [
      (_ctx.signedIn())
        ? (_openBlock(), _createBlock(_component_ion_header, {
            key: 0,
            class: "ion-no-border"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, {
                color: "primary",
                mode: "md"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_menu_button)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title),
                  (_ctx.housekeeperGroup())
                    ? (_openBlock(), _createBlock(_component_ion_select, {
                        key: 0,
                        slot: "end",
                        mode: "ios",
                        modelValue: _ctx.lang,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lang) = $event)),
                        onIonChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage($event))),
                        style: {"color":"white","font-size":"1.25rem","font-family":"'Montserrat', sans-serif"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select_option, { value: "en" }, {
                            default: _withCtx(() => [
                              _createTextVNode("English")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_select_option, { value: "es" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Español")
                            ]),
                            _: 1
                          }),
                          false
                            ? (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: 0,
                                value: "pt"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Português")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          false
                            ? (_openBlock(), _createBlock(_component_ion_select_option, {
                                key: 1,
                                value: "ru"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Русский")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_thumbnail, {
                    style: {"cursor":"pointer"},
                    slot: "end",
                    href: "/"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.signedIn())
        ? (_openBlock(), _createBlock(_component_LoginPage, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.signedIn())
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 2,
            class: "main-content",
            style: {"display":"flex","justify-content":"center","--overflow":"hidden"}
          }, {
            default: _withCtx(() => [
              (_ctx.housekeeperGroup())
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_HousekeeperComponent)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_MainMenu)
                  ]))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}